import {Box} from '@mui/material';
import * as React from 'react';
import {PropsWithChildren} from 'react';

function FlatAppBarRight(props: PropsWithChildren) {
  return (
    <Box flex={'initial'} width={45} justifyContent={'flex-end'}>
      {props.children}
    </Box>
  );
}

export {FlatAppBarRight};
